import { caughtPromise } from 'lib/axios'
import React, { useCallback, useId, useState } from 'react'
import { hideBeaconApi } from './api'

const Footer = ({ next, prev, onClose, currentStep, totalSteps, disableCheckBox = false }) => {
  const [isShowAgain, setIsShowAgain] = useState(true)
  const beaconCheckBoxId = useId()

  const hideBeacon = async (value) => {
    const [err, data] = await caughtPromise(hideBeaconApi('manual_questionnaire_v1', value))
    if (err) console.log('Failed to mark beacon as shown', err)
  }

  const handleOnChange = (e) => {
    const disableBeaconValue = e.currentTarget.checked
    setIsShowAgain(!disableBeaconValue)
    hideBeacon(disableBeaconValue)
  }

  const renderBtn = useCallback(() => {
    switch (currentStep) {
      case 0:
        return (
          <button onClick={next} type="button" className="dome-btn dome-btn-base dome-btn-dark-green">
            <span>start tutorial</span>
            <span>
              <i className="fa-light fa-arrow-right"></i>
            </span>
          </button>
        )
      case totalSteps - 1:
        return (
          <button onClick={onClose} type="button" className="dome-btn dome-btn-base dome-btn-dark-green">
            <span>close</span>
          </button>
        )
      default:
        return (
          <button onClick={next} type="button" className="dome-btn dome-btn-base dome-btn-dark-green">
            <span>next</span>
            <span>
              <i className="fa-light fa-arrow-right"></i>
            </span>
          </button>
        )
    }
  }, [currentStep])

  return (
    <div className="beacon-slider-footer dome-d-flex dome-justify-between">
      {!disableCheckBox && (
        <div className="dome-d-flex dome-align-center dome-gap6">
          <input
            id={beaconCheckBoxId}
            type="checkbox"
            style={{ margin: 0 }}
            checked={!isShowAgain}
            onChange={handleOnChange}
          />
          <label htmlFor={beaconCheckBoxId} role="button" className="dome-margin-auto dome-p3 dome-color-dark-grey">
            please do not show this again
          </label>
        </div>
      )}
      <div className="beacon-slider-footer-navigation dome-d-flex dome-flex-1 dome-justify-end dome-gap18">
        {currentStep === 0 && (
          <button type="button" onClick={onClose} className="dome-btn dome-btn-base dome-btn-grey-stroke">
            close
          </button>
        )}
        {currentStep !== 0 && (
          <button
            type="button"
            onClick={prev}
            className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
          >
            back
          </button>
        )}
        {currentStep === totalSteps - 1 && (
          <a
            href="https://static.domecile.com/announcenments/manual_questionnaires.pdf"
            target="_black"
            className="dome-link dome-is-button dome-link-grey-stroke"
          >
            download PDF
          </a>
        )}
        {renderBtn()}
      </div>
    </div>
  )
}

export default Footer
